import { reloadDatatable } from "../common/datatables";

const props = {
    coreBenefitManagementDatatableMarker: '.marker-core-benefit-management',
    coreBenefitManagementDatatable: '#dt-core-benefit-management',
    searchterm_selector: '#SearchField'
};

export function initDtAdminCoreBenefitManagement() {

    if ($(props.coreBenefitManagementDatatableMarker).length) {
        dtAdminCoreBenefitManagement(initCoreBenefitManagementDatatableEvents, props.searchterm_selector);
        setupCoreBenefitManagementSearchEvents();
    }

}

const setupCoreBenefitManagementSearchEvents = () => {

    //PURPOSE: initialises events associated with the text search field
    $(props.searchterm_selector).off("keypress").on('keypress', (e) => {
        if (e.which === 13) {
            e.preventDefault();

            reloadCoreBenefitManagementDatatable();
        }
    });

    $(props.coreBenefitstatus_selector).off("change").on("change", () => {

        reloadCoreBenefitManagementDatatable();
    });

    //PURPOSE: initialises search button click event
    $('.mdc-text-field__icon').off("click").on('click', (e) => {
        reloadCoreBenefitManagementDatatable();
    });
};


const reloadCoreBenefitManagementDatatable = () => {
    //PURPOSE: reloads user management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.coreBenefitManagementDatatable, initCoreBenefitManagementDatatableEvents, true);
};

export function initCoreBenefitManagementDatatableEvents() {

    //PURPOSE: sets up the full row click select for the user search dt
    $(props.coreBenefitManagementDatatable).off('click').on('click', 'tbody td', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var coreBenefitId = $(event.currentTarget).parent('tr').data('id');

        window.location.href = '/administration/benefitmanagement/editcorebenefit/' + coreBenefitId;
    });
}


function dtAdminCoreBenefitManagement(onloadCallback, searchterm_selector) {

    if ($(props.coreBenefitManagementDatatable).length === 0) return false;

    $(props.coreBenefitManagementDatatable).DataTable({
        iDisplayLength: 100,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/benefitmanagement/corebenefitmanagementsearch',
            data: function (d) {
                d.searchterm = $(searchterm_selector).val();
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'title', name: 'Title' },
            { data: 'imageConfigured', name: 'Image Configured' },
            {
                name: '',
                data: null,
                sortable: false,
                render: function (o) {

                    return '<div class="mdc-button mdc-button--raised bg-green text-white min-width-100 hidden-xs mr-2">View</div>'
                },
                class: 'text-align-right'
            }
        ],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}
